import { createFileRoute, redirect } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Services/')({
    loader: ({ params: { currentEnterpriseId } }) => {
        throw redirect({
            to: '/$currentEnterpriseId/Service/Index',
            params: { currentEnterpriseId },
            search: { OwnerId: currentEnterpriseId },
        });
    },
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Redirect,
    },
});
